// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASE COLOR
------------------------------------------------------------*/
/* DISPLAY SETTING
------------------------------------------------------------*/
/* OTHER SETTING
------------------------------------------------------------*/
[data-v-18c2bfa6]:root {
  font-size: clamp(13px + 2 * (100vw - 1440px) / 480, 1vw, 16px + 2 * (100vw - 1440px) / 480);
  --cx: 0;
  --cy: 0;
  --vw: 100vw;
  --vh: 100vh;
  --screen: 0px;
  --size: 32px;
}
@media screen and (min-width: 1920px) {
[data-v-18c2bfa6]:root {
    font-size: 16px;
}
}
@media screen and (max-width: 1023px) {
[data-v-18c2bfa6]:root {
    font-size: 14px;
    --size: 16px;
}
}
@media screen and (max-width: 769px) {
[data-v-18c2bfa6]:root {
    font-size: 13.5px;
    --size: 10px;
}
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 100;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 200;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 300;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 400;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 500;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}
.main[data-v-18c2bfa6] {
  position: relative;
  width: 100%;
  z-index: 10;
}
.pic[data-v-18c2bfa6] {
  position: relative;
  padding: 32.5% 0 0;
  border-radius: 0 0 0 1vw;
  overflow: hidden;
  min-height: 32rem;
  width: 72%;
  margin: 0 0 0 auto;
  transform: translateX(15%) skewX(24deg);
  z-index: 1;
  animation: shadowAnimation-18c2bfa6 1000ms 200ms ease-in-out forwards;
}
@media screen and (max-width: 1023px) {
.pic[data-v-18c2bfa6] {
    padding: 43.75% 0 0;
    min-height: 1rem;
    width: 80%;
}
}
@media screen and (max-width: 769px) {
.pic[data-v-18c2bfa6] {
    padding: 50% 0 0;
    width: 56%;
}
}
@keyframes shadowAnimation-18c2bfa6 {
0% {
    box-shadow: 0 0 0 rgba(32, 43, 43, 0);
}
100% {
    box-shadow: 1.2rem 1.2rem 6.4rem rgba(0, 161, 153, 0.24);
}
}
.pic img[data-v-18c2bfa6] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.1) skewX(-24deg);
  opacity: 0;
  animation: slidePic-18c2bfa6 1000ms 200ms ease-in-out forwards;
}
@media screen and (max-width: 1023px) {
.pic img[data-v-18c2bfa6] {
    width: 120%;
    left: -10%;
}
}
@keyframes slidePic-18c2bfa6 {
0% {
    opacity: 0;
    transform: translateX(-10%) scale(1.1) skewX(-24deg);
}
100% {
    opacity: 1;
    transform: translateX(-10%) scale(1) skewX(-24deg);
}
}
.title[data-v-18c2bfa6] {
  height: 100%;
  position: absolute;
  left: 5%;
  top: 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  line-height: 1;
  white-space: nowrap;
  z-index: 2;
}
@media screen and (max-width: 1023px) {
.title[data-v-18c2bfa6] {
    top: 5%;
}
}
@media screen and (max-width: 769px) {
.title[data-v-18c2bfa6] {
    top: 10%;
}
}
@keyframes slideTitle-18c2bfa6 {
0% {
    opacity: 0;
    transform: translateY(2rem);
}
100% {
    opacity: 1;
    transform: translateY(0);
}
}
.title h1[data-v-18c2bfa6], .title p[data-v-18c2bfa6] {
  opacity: 0;
  font-weight: 700;
}
.title p[data-v-18c2bfa6] {
  letter-spacing: 0;
  font-size: clamp(4.8rem, 12.5vmin, 8rem);
  color: #00a199;
  animation: slideTitle-18c2bfa6 800ms 400ms ease-in-out forwards;
}
@media screen and (max-width: 1023px) {
.title p[data-v-18c2bfa6] {
    font-size: 3.2rem;
}
}
@media screen and (max-width: 769px) {
.title p[data-v-18c2bfa6] {
    font-size: 1.8rem;
}
}
.title h1[data-v-18c2bfa6] {
  font-size: 2.4vmin;
  text-indent: 1vmin;
  margin: 4.8vmin 0 1.2vmin;
  animation: slideTitle-18c2bfa6 800ms 200ms ease-in-out forwards;
}
@media screen and (max-width: 1023px) {
.title h1[data-v-18c2bfa6] {
    font-size: 1.2rem;
    margin: 0 0 1rem;
    text-indent: 0;
}
}
@media screen and (max-width: 769px) {
.title h1[data-v-18c2bfa6] {
    font-size: 0.92rem;
    margin: 0 0 0.8rem;
}
}
.bread[data-v-18c2bfa6] {
  position: absolute;
  bottom: 0;
  left: calc(var(--size) + 2vw);
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/scss/module/_module.scss","webpack://./hero.vue","webpack://./src/js/components/hero.vue"],"names":[],"mappings":"AAEA;6DAAA;AAeA;6DAAA;AAOA;6DAAA;AAEA;EACC,2FAAA;EAKC,OAAA;EACD,OAAA;EACA,WAAA;EACA,WAAA;EACC,aAAA;EACA,YAAA;ACtBF;ADuBC;AAZD;IAaE,eAAA;ACpBA;AACF;ADqBC;AAfD;IAgBE,eAAA;IACE,YAAA;AClBF;AACF;ADmBC;AAnBD;IAoBE,iBAAA;IACE,YAAA;AChBF;AACF;AD0HA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,4BAAA;EACA,iBAAA;ACvHD;AC7DA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AD+DF;AC7DA;EACE,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;EACA,qEAAA;ADgEF;AC/DE;AAXF;IAYI,mBAAA;IACA,gBAAA;IACA,UAAA;ADkEF;AACF;ACjEE;AAhBF;IAiBI,gBAAA;IACA,UAAA;ADoEF;AACF;ACnEE;AACE;IACE,qCAAA;ADqEJ;ACnEE;IACE,wDAAA;ADqEJ;AACF;ACnEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mCAAA;EACA,UAAA;EACA,8DAAA;ADqEJ;ACpEI;AAVF;IAWI,WAAA;IACA,UAAA;ADuEJ;AACF;ACtEI;AACE;IACE,UAAA;IACA,oDAAA;ADwEN;ACtEI;IACE,UAAA;IACA,kDAAA;ADwEN;AACF;ACpEA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EFbD,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;EEYA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AD0EF;ACzEE;AAXF;IAYI,OAAA;AD4EF;AACF;AC3EE;AAdF;IAeI,QAAA;AD8EF;AACF;AC7EE;AACE;IACE,UAAA;IACA,2BAAA;AD+EJ;AC7EE;IACE,UAAA;IACA,wBAAA;AD+EJ;AACF;AC7EE;EACE,UAAA;EACA,gBAAA;AD+EJ;AC7EE;EACE,iBAAA;EACA,wCAAA;EACA,cFpFG;EEqFH,+DAAA;AD+EJ;AC9EI;AALF;IAMI,iBAAA;ADiFJ;AACF;AChFI;AARF;IASI,iBAAA;ADmFJ;AACF;ACjFE;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+DAAA;ADmFJ;AClFI;AALF;IAMI,iBAAA;IACA,gBAAA;IACA,cAAA;ADqFJ;AACF;ACpFI;AAVF;IAWI,kBAAA;IACA,kBAAA;ADuFJ;AACF;ACpFA;EACE,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;ADuFF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
